module.exports = __webpack_public_path__ + "static/halloween-4c46252c42c597fb8225337d40767b7d.jpg";